import { DisplayNames } from "./displayNames";

export class Organization {
    constructor(
        public displayNames: DisplayNames
    ) { }

    public static create(): Organization {
        return new Organization(DisplayNames.create())
    }
}